







import { ResizeObserver as ResizeObserverPolyfill } from '@juggle/resize-observer';

export default {
  name: 'epb-fading-scroll',
  data: function () {
    return {
      baseClass: 'epb-fading-scroll',
      bottomReached: true,
      resizeObserver: undefined,
      mutationObserver: undefined
    };
  },
  methods: {
    setBottomReached: function (): void {
      const { offsetHeight, scrollTop, scrollHeight } = this.$el;
      this.bottomReached = offsetHeight + scrollTop >= scrollHeight;
    }
  },
  mounted: function (): void {
    const ResizeObserver = (window['ResizeObserver'] || ResizeObserverPolyfill);
    const MutationObserver = window['MutationObserver'];
    const mutationObserverConfig = { attributes: true, childList: true, subtree: true };
    this.resizeObserver = new ResizeObserver(this.setBottomReached);
    this.mutationObserver = new MutationObserver(this.setBottomReached);
    this.resizeObserver.observe(this.$el);
    this.mutationObserver.observe(this.$el, mutationObserverConfig);
  },
  beforeDestroy: function (): void {
    this.resizeObserver.disconnect();
    this.mutationObserver.disconnect();
  }
};

